<template>
  <div class="container-fluid">
    <div class="" v-if="event">
      <div class="row">
        <div class="col-12">
          <StudioCheckout
            viewButtonText="PRODUCTS.BUTTON.RETURN_TO_EVENT"
            viewRouteName="studio-event-details"
            :eventId="eventId"
          >
            <template #breadcrumbs>
              <div class="small">
                <div class="d-flex">
                  <span
                    class="back-button pointer d-md-none"
                    @click="$router.go(-1)"
                  >
                    <i class="fal fa-chevron-left"></i>
                  </span>
                  <StudioLogo class="logo-image mb-2" :studio="studio" />
                </div>
                <hr class="d-block d-md-none mt-2 mb-3 p-0" />
                <NuxtLink
                  :to="{ name: 'studio-event-details' }"
                  class="c-coral"
                >
                  <span>{{ event.event_name }}</span>
                </NuxtLink>
                <span class="mx-2 mx-md-3">
                  <i class="fal fa-chevron-right"></i>
                </span>
                <NuxtLink
                  v-if="eventProducts.length > 1"
                  :to="{ name: 'studio-event-select-product' }"
                  class="c-coral"
                >
                  <span>
                    {{ $t('STUDIO.LABELS.BREADCRUMB_SELECT_PRODUCT') }}
                  </span>
                </NuxtLink>
                <span v-if="eventProducts.length > 1" class="mx-2 mx-md-3">
                  <i class="fal fa-chevron-right"></i>
                </span>
                <span class="c-charcoal">
                  {{ $t('STUDIO.LABELS.BREADCRUMB_CHECKOUT') }}
                </span>
              </div>
            </template>
          </StudioCheckout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorToMessage } from '@/utils/errors';
import StudioCheckout from '@/components/checkout/StudioCheckout.vue';
import StudioLogo from '@/components/navigation/StudioLogo.vue';
import { mapState } from 'pinia';
import { useEventStore, useStudioStore, useUserStore } from '@/stores';

export default {
  name: 'StudioEventProductCheckout',
  components: {
    StudioCheckout,
    StudioLogo,
  },
  setup() {
    definePageMeta({
      name: 'studio-event-product-checkout',

      isStudio: true,
      hideInstagramSlider: true,
      hideTopBar: true,
      hideStudioContactInformation: true,
      preventRefreshModal: true,
      hideMobileNav: true,
      hideCookieNotice: true,
    });
  },
  computed: {
    ...mapState(useEventStore, {
      event: 'eventDetails',
      eventProducts: 'eventProducts',
    }),
    ...mapState(useStudioStore, {
      studio: 'currentStudio',
      currency: 'currency',
    }),
    ...mapState(useUserStore, {
      isLoggedIn: 'isLoggedIn',
    }),
    studioURL() {
      return this.$studioURL;
    },
    eventId() {
      return parseInt(this.$route.params.event_id);
    },
    productId() {
      return this.$route.params.product_id;
    },
  },
  data() {
    return {
      loadError: null,
    };
  },
  methods: {},
  mounted() {
    useEventStore()
      .getStudioEventDetails({
        studioURL: this.studioURL,
        eventId: this.eventId,
      })
      .catch(error => {
        this.loadError = this.$t('EVENTS.TEXT.WHOOPS_COULD_NOT_FIND_EVENT');
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Event load failed',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.logo-image {
  display: block;
  height: 60px;
  width: auto;
}

.back-button {
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-left: -10px;
}
</style>
